import router from '@/router';

export let appVersion = localStorage.getItem('APP_VERSION') || null;
export let versionChanged = false;
export let interval = null;

export function checkAppVersion() {
    router.beforeEach((to, from, next) => {
        if (versionChanged) {
            window.location.reload();
        }
        next();
    });
    checkVersion();
    interval = setInterval(() => {
        checkVersion();
    }, 60000);
}

function checkVersion(){
    http.get('api/version')
        .then(response => {
            if (!appVersion) {
                appVersion = response.data.version;
                localStorage.setItem('APP_VERSION', appVersion);
                localStorage.setItem('MAINTENANCE_MODE', response.data.maintenance_mode)
            } else if (appVersion !== response.data.version) {
                clearInterval(interval);
                versionChanged = true;
                console.log('New version available');
                localStorage.setItem('APP_VERSION', response.data.version);
                localStorage.setItem('MAINTENANCE_MODE', response.data.maintenance_mode)
            } else {
                const maintenanceMode = response.data.maintenance_mode ?? false;
                localStorage.setItem('MAINTENANCE_MODE', maintenanceMode)
            }
        }, error => {
            console.error(error);
        });
}
